module.exports = __webpack_public_path__ + "images/cd1864ab73df5b8a4575cdd78d6753fc.svg";